import presto from 'packages/superset-ui-chart-controls/src/components/ColumnTypeLabel/type-icons/Presto.svg';
import postgreSQL from 'packages/superset-ui-chart-controls/src/components/ColumnTypeLabel/type-icons/PostgreSQL.svg';
import sqlite from 'packages/superset-ui-chart-controls/src/components/ColumnTypeLabel/type-icons/SQLite.svg';
import mysql from 'packages/superset-ui-chart-controls/src/components/ColumnTypeLabel/type-icons/MySQL.svg';



const DatabaseIcons = {
    "Presto":presto,
    "PostgreSQL":postgreSQL,
    "SQLite":sqlite,
    "MySQL":mysql,
}

export default DatabaseIcons;